import {DEFAULT_RGB} from "../../constants/config";
import Color from "./Color";

/**
 * @class SearchPanelColor
 */
export default class SearchPanelColor extends Color {
    /**
     * @param {Number}          id
     * @param {String}          name
     * @param {String}          displayName
     * @param {String}          code
     * @param {String}          rgb
     * @param {Boolean}         local
     * @param {Boolean}         hasFormula
     * @param {Boolean}         rgbOverride
     */
    constructor(id, name, displayName, code, rgb = DEFAULT_RGB, local = false, hasFormula = true, rgbOverride = false) {
        super(id, name, displayName, code, rgb, local, hasFormula);

        this._rgbOverride = rgbOverride;
    }

    /**
     * @return {Boolean}
     */
    get rgbOverride() {
        return this._rgbOverride;
    }

    /**
     * @return {SearchPanelColor}
     */
    clone = () => {
        return new SearchPanelColor(
            this._id,
            this._name,
            this._displayName,
            this._code,
            this._rgb,
            this._local,
            this._hasFormula,
            this._rgbOverride
        );
    };
}
